module.exports = __webpack_public_path__ + "img/message_icon.dfe796e5.svg";